import React from 'react';
import PropTypes from 'prop-types';

import './footer.scss';
import '../../../../assets/icons/Icon_YouTube.svg';
import '../../../../assets/icons/Icon_Vimeo.svg';
import '../../../../assets/icons/Icon_Facebook.svg';
import '../../../../assets/icons/Icon_Twitter.svg';
import '../../../../assets/icons/Icon_Instagram.svg';
import '../../../../assets/icons/Icon_GPlus.svg';

const FooterView = props => (
  <div className={'m-footer'}>
    <div className={'m-footer__copyright'}>
      {props.copyright}
    </div>
    <div className={'m-footer__externals'}>
      <ul>
        {props.externals.map(link => (
          <li key={link.label}>
            <a href={link.url} target={link.blank ? '_blank' : '_self'} rel="noopener">{link.label}</a>
          </li>
        ))}
      </ul>
    </div>
    <div className={'m-footer__social'}>
      <a className={'m-footer__icon'} href={props.social.yt} target={'_blank'} rel="noopener">
        <svg>
          <use xlinkHref="#Icon_YouTube" />
        </svg>
      </a>
      <a className={'m-footer__icon'} href={props.social.vimeo} target={'_blank'} rel="noopener">
        <svg>
          <use xlinkHref="#Icon_Vimeo" />
        </svg>
      </a>
      <a className={'m-footer__icon'} href={props.social.fb} target={'_blank'} rel="noopener">
        <svg>
          <use xlinkHref="#Icon_Facebook" />
        </svg>
      </a>
      <a className={'m-footer__icon'} href={props.social.twitter} target={'_blank'} rel="noopener">
        <svg>
          <use xlinkHref="#Icon_Twitter" />
        </svg>
      </a>
      <a className={'m-footer__icon'} href={props.social.instagram} target={'_blank'} rel="noopener">
        <svg>
          <use xlinkHref="#Icon_Instagram" />
        </svg>
      </a>
    </div>
    <div className={'m-footer__legals'}>
      <ul>
        {props.legals.map(link => (
          <li key={link.label}>
            <a href={link.url} target={link.blank ? '_blank' : '_self'} rel="noopener">{link.label}</a>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

FooterView.propTypes = {
  copyright: PropTypes.string.isRequired,
  externals: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    blank: PropTypes.bool.isRequired,
  }).isRequired).isRequired,
  social: PropTypes.shape({
    yt: PropTypes.string.isRequired,
    vimeo: PropTypes.string.isRequired,
    fb: PropTypes.string.isRequired,
    twitter: PropTypes.string.isRequired,
    instagram: PropTypes.string.isRequired,
    google: PropTypes.string.isRequired,
  }).isRequired,
  legals: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    blank: PropTypes.bool.isRequired,
  }).isRequired).isRequired,
};

export default FooterView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Globals/Footer/FooterView.jsx